(() => {
  if (window.southwoodCollectionReturn) return;
  window.southwoodCollectionReturn = true;
  const key = 'southwood:collection-return';
  const pageKey = () => location.pathname.replace(/\/$/, '') + location.search;
  let cancel = () => {};
  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  };
  const remove = () => { try { sessionStorage.removeItem(key); } catch {} };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    const card = link?.closest('.product');
    if (!card || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    cancel();
    const data = {page: pageKey(), product: url.pathname, top: (card.querySelector('.product-title') || card).getBoundingClientRect().top, y: window.scrollY, time: Date.now()};
    try { sessionStorage.setItem(key, JSON.stringify(data)); } catch {}
  }, true);
  function restore() {
    const saved = read();
    if (!saved || saved.page !== pageKey() || Date.now() - saved.time > 900000) return;
    cancel();
    const previous = history.scrollRestoration;
    history.scrollRestoration = 'manual';
    let stopped = false;
    const started = performance.now();
    const stop = () => {
      if (stopped) return;
      stopped = true;
      history.scrollRestoration = previous;
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(type => window.removeEventListener(type, stop));
      remove();
    };
    cancel = stop;
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(type => window.addEventListener(type, stop, {passive: true, once: true}));
    function place() {
      if (stopped) return;
      const link = Array.from(document.querySelectorAll('.product a[href]')).find(el => new URL(el.href, location.href).pathname === saved.product);
      const card = link?.closest('.product');
      if (card && !document.body.classList.contains('ajax_loading')) {
        const y = window.scrollY + (card.querySelector('.product-title') || card).getBoundingClientRect().top - saved.top;
        if (Math.abs(window.scrollY - y) > 1) window.scrollTo({top: Math.max(0, y), behavior: 'instant'});
      }
      if (performance.now() - started < 4000) setTimeout(place, 60);
      else stop();
    }
    requestAnimationFrame(place);
  }
  window.addEventListener('pageshow', event => {
    if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') restore();
  });
  if (document.readyState === 'complete' && performance.getEntriesByType('navigation')[0]?.type === 'back_forward') restore();
})();
